module.exports = __webpack_public_path__ + "static/img/Ollie_Wines_mobile.cd7633a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ollie_Wines_mobile.jpg
// module id = hS+8
// module chunks = 0